export default __webpack_public_path__ + "static/media/wifi_bad_signal.59891c8b.svg";